import React from 'react';
import { StyleSheet, View } from 'react-native';
import { CommonStyles, CommonProperties, Color } from '../../styles';
import BaseText from '../BaseText';

const HeaderAccentTitle = ({ title, subtitle }) => {
  return (
    <View style={CommonStyles.centerAlignment}>
      <BaseText style={styles.title}>{title}</BaseText>
      <BaseText style={styles.subtitle}>{subtitle}</BaseText>
    </View>
  );
};

const styles = StyleSheet.create({
  title: {
    ...CommonProperties.h4,
    color: Color.accent,
  },
  subtitle: {
    ...CommonProperties.small,
    color: Color.accent,
  },
});

export default HeaderAccentTitle;
